module.exports = __webpack_public_path__ + "static/img/8668_phase_function_Paper_PointsHejduk_Prediction.7a66c54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/8668_phase_function_Paper_PointsHejduk_Prediction.png
// module id = qI44
// module chunks = 0